import React, { useEffect, useState } from "react";
import "../style/gallery.scss";

import img1 from "../img/gallery/milica.webp";
import img2 from "../img/gallery/natalija.webp";
import img3 from "../img/gallery/natasa.webp";
import img4 from "../img/gallery/vera.webp";
import img5 from "../img/gallery/stoja.webp";
import ActionSection from "../components/ActionSection";

const images = [img1, img2, img3, img4, img5];

export default function Gallery() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handleKeyDown = (event) => {
    if (selectedImageIndex !== null) {
      if (event.key === "ArrowLeft") {
        handlePrev();
      } else if (event.key === "ArrowRight") {
        handleNext();
      } else if (event.key === "Escape") {
        handleClose();
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  return (
    <>
      <div className="container banner">
        <div className="wrapper p-30">
          <div className="title-box">
            <h1 className="title" data-aos="fade-down">Galerija puder obrva</h1>
            <h2 className="subtitle" data-aos="fade-down">Galerija</h2>
          </div>
        </div>
      </div>

      <div className="gallery-container wrapper">
        {images.map((src, index) => (
      
            <img data-aos="zoom-in" onClick={() => setSelectedImageIndex(index)} key={index} src={src} alt="Galerija radova - Heli Brows" />
        ))}
      </div>

      {selectedImageIndex !== null && (
        <div className="modal">
          <span className="close" onClick={handleClose}>
            ✕
          </span>
          <img
            className="modal-content"
            src={images[selectedImageIndex]}
            alt="Selected"
          />
          <span className="prev" onClick={handlePrev}>
            &#10094;
          </span>
          <span className="next" onClick={handleNext}>
            &#10095;
          </span>
        </div>
      )}

       <div data-aos="zoom-in">
              <ActionSection />
            </div>
    </>
  );
}
